<template>
  <app-layout>
    <template v-slot:submenu>
      <sub-menu>
        <router-link :to="{ name: 'ShowIssue', params: { id: issue_uuid } }" class="btn btn-outline-dark">
          <show-icon name="back" size="sm" class="align-middle"></show-icon>
          {{ $t("back") }}
        </router-link>
      </sub-menu>
    </template>

    <template v-slot:default>
      <IssueForm 
        :issue-uuid="issue_uuid"
        @issue-updated="onIssueUpdated"
      ></IssueForm>
    </template>
  </app-layout>
</template>
<script>
//import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import IssueForm from './Form.vue';

export default {
  name: "IssueEdit",
  setup() { 
    const route = useRoute();
    const router = useRouter();
    const issue_uuid = route.params.id;

    const onIssueUpdated = function(e) {      
      console.log("views/issues/Edit.vue, onIssueUpdated, e.issueUUID ==> ", e.issueUUID);
      router.push({ name: "ShowIssue", params: { id: e.issueUUID} });
    }
    return {
      issue_uuid,
      onIssueUpdated
    }    
  },
  components: {
    IssueForm
  }
}
</script>